import axios from "axios";
import { BE_URL } from "config/api";
import * as absence from "./absence";
import * as auth from "./auth";
import * as bin from "./bin";
import * as checklists from "./checklists";
import * as orders from "./orders";
import * as approve from "./approve";
import * as users from "./users";
import * as statistics from "./statistics";
import * as companies from "./companies";
import * as customers from "./customers";
import * as departments from "./departments";
import * as offices from "./offices";
import * as bookings from "./bookings";
import * as orderIncompleteReasons from "./order-incomplete-reasons";

export const client = axios.create({
  baseURL: BE_URL,
});

const api = {
  absence,
  auth,
  bin,
  checklists,
  orders,
  approve,
  users,
  statistics,
  companies,
  customers,
  departments,
  offices,
  bookings,
  orderIncompleteReasons,
};

export default api;
